<script setup lang="ts">
/**
 * UI-kit component
 * Category: Loaders
 * Name: SkeletonBox
 * FIGMA: —
 *
 * A shimmering placeholder the size of the content it stands in for. Sized by the caller (props or
 * a class): the skeleton has no opinion about what it is a skeleton OF.
 */
import type { SkeletonBoxProps } from '../types/interfaces'

defineOptions({
  name: 'SkeletonBox',
})

withDefaults(defineProps<SkeletonBoxProps>(), {
  width: '100%',
  height: '100%',
  rounded: 'sm',
  label: 'Loading…',
})
</script>

<template>
  <span
    class="skeleton-box"
    :class="`skeleton-box--${rounded}`"
    :style="{ width, height }"
    role="status"
    :aria-label="label"
  />
</template>

<style lang="scss" scoped src="../styles/_skeleton-box.scss" />
